import React from "react";
import GeneralNavbar from "../../components/Navbar/GeneralNavbar";
import "./ErrorPage.css";

const ErrorPage = () => {
	return (
		<>
			<GeneralNavbar />
			<div className="error-container">
				<h1>404 Not Found</h1>
				<p>Oops! The page you're looking for doesn't exist.</p>
				<a href="/">Go Back Home</a>
			</div>
		</>
	);
};

export default ErrorPage;
